import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/topbar";
import Sidebar from "../components/sidebar";
import Footer from "../components/footer";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_URL = `${BASE_URL}admin/getdata/insert_banner.php`;
const IMG_URL = `${BASE_URL}img/banner/`;

  const WebBanner = () => {
  const [banners, setBanners] = useState([]);
  const [title, setTitle] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [editing, setEditing] = useState(null);
  const [message, setMessage] = useState("");

  // ✅ Fetch Banner List
  const fetchBanners = async () => {
    const res = await axios.get(API_URL);
    setBanners(res.data);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  // ✅ Upload Image Function
  const uploadImage = async () => {
    const formData = new FormData();
    formData.append("image", imageFile); // IMPORTANT key

    const res = await axios.post(
      `${API_URL}?action=upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data.file;
  };

  // ✅ Submit Banner
  const handleSubmit = async (e) => {
    e.preventDefault();

    let imageName = editing?.image || "";

    // Upload only if file selected
    if (imageFile) {
      imageName = await uploadImage();
    }

    if (editing) {
      await axios.post(`${API_URL}?action=update`, {
        id: editing.id,
        title,
        image: imageName,
      });

      setMessage("✅ Banner Updated Successfully");
    } else {
      await axios.post(`${API_URL}?action=create`, {
        title,
        image: imageName,
      });

      setMessage("✅ Banner Added Successfully");
    }

    // Reset Form
    setTitle("");
    setImageFile(null);
    setEditing(null);

    fetchBanners();
  };

  // ✅ Edit Banner
  const handleEdit = (item) => {
    setEditing(item);
    setTitle(item.title); // FIXED (was item.name)
  };

  // ✅ Delete Banner
  const handleDelete = async (id) => {
    if (window.confirm("Delete this banner?")) {
      await axios.post(`${API_URL}?action=delete`, { id });
      fetchBanners();
      setMessage("✅ Banner Deleted Successfully");
    }
  };

  return (
    <div className="header-light sidebar-dark sidebar-expand">
      <Topbar />

      <div className="content-wrapper">
        <Sidebar />

        <main className="main-wrapper clearfix">
          <div className="container mt-4">

            <h3>Upload Banner</h3>

            {message && (
              <div className="alert alert-info py-2">{message}</div>
            )}

            {/* Form */}
            <div className="card mt-3">
              <div className="card-header">
                {editing ? "Edit Banner" : "Add Web Banner"}
              </div>

              <div className="card-body">
                <form onSubmit={handleSubmit}>

                  <label>Banner Image</label>
                  <input
                    type="file"
                    className="form-control mb-3"
                    onChange={(e) =>
                      setImageFile(e.target.files[0])
                    }
                  />

                  <label>Title</label>
                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Banner title"
                    value={title}
                    onChange={(e) =>
                      setTitle(e.target.value)
                    }
                  />

                  <button className="btn btn-primary">
                    {editing ? "Update" : "Submit"}
                  </button>

                </form>
              </div>
            </div>

            {/* List */}
            <div className="card mt-4">
              <div className="card-header">Banner List</div>

              <table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Title</th>
                    <th width="150">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {banners.length > 0 ? (
                    banners.map((a, i) => (
                      <tr key={a.id}>
                        <td>{i + 1}</td>

                        <td>
                          <img
                            src={IMG_URL + a.image}
                            width="60"
                            height="50"
                            alt=""
                          />
                        </td>

                        <td>{a.title}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-secondary me-2"
                            onClick={() => handleEdit(a)}
                          >
                            ✏️
                          </button>

                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(a.id)}
                          >
                            🗑
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        No Banner Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default WebBanner;
